<form [formGroup]="_form">
    <div class="form-group">
        <div class="form-row">
            <label class="form-row__label">{{ ".FlagStatus" | lgTranslate }}</label>
            <div>
                <flags-menu
                    formControlName="flagId"
                    [definition]="_definition"
                    [showWarningIfOverride]="false"
                >
                </flags-menu>
            </div>
        </div>
        <div class="form-row form-row--input">
            <label class="form-row__label">{{ ".Comment" | lgTranslate }}</label>
            <div class="form-row__controls">
                <textarea class="textarea" formControlName="comment" rows="4"></textarea>
            </div>
        </div>
    </div>
    <div class="form-group form-group--buttons">
        <div class="form-row">
            <lg-button
                buttonClass="button--primary"
                type="submit"
                [isDisabled]="_isSubmitDisabled"
                textLc="FW.SAVE"
                (click)="_onSubmit()"
            >
            </lg-button>
            <lg-button buttonClass="button--secondary" [textLc]="'FW.CANCEL'" (click)="_cancel()">
            </lg-button>
        </div>
    </div>
</form>
